import React from "react";
import { FormField, Button, Box } from "@nef/core";
import styled from "styled-components";

const StyledInformationCollection = styled(Box)`
  &.information-collection {
    width: 500px;
    margin: auto;
    margin-top: 50px;
    margin-bottom: 50px;

    .button {
      display: block;
      margin: auto;
    }
  }
`;

export default StyledInformationCollection;
